import { ProcessingStep } from '../entities/processing-step.entity';

export const RECORD_PROCESSING_STEPS: ProcessingStep[] = [
    new ProcessingStep('ingest', ['SET_FIELD', 'SET_STATUS', 'DOWNLOAD_URL']),
    new ProcessingStep('virus-check', ['VIRUS_CHECK']),
    new ProcessingStep('md5-check', ['MD5']),
    new ProcessingStep('format-check', ['PRONOM']),
    new ProcessingStep('metadata-extraction', ['HARVEST', 'KEYWORD_HARVEST', 'OCR']),
    new ProcessingStep('transform', ['TRANSCODE', 'REPRESENTATION']),
    new ProcessingStep('extract-attachments', ['LIST_EXTRACTIONS', 'INGEST_EXTRACTION'], true),
    new ProcessingStep('ai-enhancement', ['INSIGHTS', 'EMBEDDINGS', 'GENERATIVE_METADATA'], true),
    new ProcessingStep('store', ['TRANSFER'])
];

export const COMBINED_PROCESSING_STEPS: ProcessingStep[] = [
    new ProcessingStep('ingest', ['COMBINED_INGEST_VALIDATION_AND_TRANSFER']),
    new ProcessingStep('transform', ['COMBINED_INGEST_TRANSFORMATIONS']),
    new ProcessingStep('metadata-extraction', ['COMBINED_INGEST_EXTRACTIONS'], true),
    new ProcessingStep('ai-enhancement', ['COMBINED_INGEST_AI'], true),
    new ProcessingStep('store', ['COMBINED_INGEST_COMPLETION'])
];

export const SIP_PROCESSING_STEPS: ProcessingStep[] = [
    new ProcessingStep('ingest', ['SET_FIELD']),
    new ProcessingStep('validation', ['ZIP_VALIDATION', 'ZIP_VALIDATION_SIDECAR']),
    new ProcessingStep('extraction', ['ZIP_INGEST_INTELLECTUAL_OBJECTS', 'ZIP_INGEST_FILE'], true),
    new ProcessingStep('delete', ['DELETE_RECORD'])
];
